(($) => {
    'use strict'

    const $datesPublish = $("input[name='dates_publication']");
    if ($datesPublish.length === 0) {
        return;
    }

    let $startDate = $('#start_date_publication');
    let $endDate = $('#end_date_publication');
    let startDateValue = moment().startOf('day');
    let endDateValue = moment().endOf('day');

    if ($startDate.length && $endDate.length) {
        if ($startDate.val() !== '' && $endDate.val() !== '') {
            startDateValue = new Date($startDate.val())
            endDateValue = new Date($endDate.val())
        } else {
            $startDate.val(startDateValue.format('YYYY-MM-DD H:mm'));
            $endDate.val(endDateValue.format('YYYY-MM-DD H:mm'));
        }
    }


    $datesPublish.daterangepicker({
        opens: 'right',
        showDropdowns: true,
        timePicker: true,
        timePicker24Hour: true,
        startDate: startDateValue,
        endDate: endDateValue,
        autoApply: true,
        locale: {
            format: 'DD/MM/YYYY H:mm',
            cancelLabel: 'Annuler',
            applyLabel: 'Appliquer',
            fromLabel: 'Du',
            toLabel: 'Au'
        },
    }).on('hide.daterangepicker', function (ev, picker) {
        $startDate.val(picker.startDate.format('YYYY-MM-DD H:mm'));
        $endDate.val(picker.endDate.format('YYYY-MM-DD H:mm'));
    });

})($);